import {
  IProductPrice,
  IProductPricePaymentInstallment,
} from "../../core/types/Product"
import { TSaleProduct } from "../../core/types/Sale"
import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutDetailsDefault from "./Layouts/LayoutDefault/CheckoutDetailsDefault"
import CheckoutDetails2 from "./Layouts/Layout2/CheckoutDetails2"
import React from "react"
import CheckoutDetails3 from "./Layouts/Layout3/CheckoutDetails3"
import CheckoutDetails4 from "./Layouts/Layout4/CheckoutDetails4"
import CheckoutDetails5 from "./Layouts/Layout5/CheckoutDetails5"
import CheckoutDetails6 from "./Layouts/Layout6/CheckoutDetails6"
import CheckoutDetails7 from "./Layouts/Layout7/CheckoutDetails7"
import CheckoutDetails8 from "./Layouts/Layout8/CheckoutDetails8"

interface ICheckoutDetails {
  layout?: TCheckoutLayout
  data: IProductPrice | null
  products: TSaleProduct[]
  paymentMethodType: number
  paymentInstallment: number
  productInstallments?: IProductPricePaymentInstallment[] | null
  paymentTotal: number
  paymentValue: number
}

const CheckoutDetails = ({
  layout,
  data,
  products,
  paymentMethodType,
  paymentInstallment,
  productInstallments,
  paymentTotal,
  paymentValue,
}: ICheckoutDetails) => {
  if (!layout) return <></>

  const checkoutDetailsData = {
    [TCheckoutLayout.Default]: (
      <CheckoutDetailsDefault
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutDetails2
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutDetails3
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutDetails4
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutDetails5
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutDetails6
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout7]: <CheckoutDetails7 />,
    [TCheckoutLayout.Layout8]: (
      <CheckoutDetails8
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        productInstallments={productInstallments}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
  }

  return checkoutDetailsData[layout] || <></>
}

export default CheckoutDetails
